/**
 * Bundled CSL locale term definitions, inlined as string constants.
 *
 * Inlined (not read from disk) so they are guaranteed present in the compiled
 * webpack server bundle: production code never reads the sibling `csl/*.xml`
 * files at runtime (only tests do) and the server webpack build copies no
 * assets, so a runtime file read from the bundle would fail. This mirrors how
 * the default en-US locale is inlined in `csl.ts`.
 *
 * Source: citation-style-language/locales @ 6b0cb4689127a69852f48608b6d1a879900f418b
 * (the same pinned commit `getLocaleXML` in `references.ts` fetches from).
 * Licensed CC BY-SA 3.0.
 *
 * To add a locale: fetch `locales-<code>.xml` from that commit and add an entry.
 */
export const bundledLocaleXML: Record<string, string> = {
  "de-AT": `<?xml version="1.0" encoding="utf-8"?>
<locale xmlns="http://purl.org/net/xbiblio/csl" version="1.0" xml:lang="de-AT">
  <info>
    <translator>
      <name>Till A. Heilmann</name>
    </translator>
    <translator>
      <name>Georg Duffner</name>
    </translator>
    <translator>
      <name>Sebastian Karcher</name>
    </translator>
    <translator>
      <name>Sylvester Keil</name>
    </translator>
    <translator>
      <name>jakov</name>
    </translator>
    <translator>
      <name>Frank Bennett</name>
    </translator>
    <rights license="http://creativecommons.org/licenses/by-sa/3.0/">This work is licensed under a Creative Commons Attribution-ShareAlike 3.0 License</rights>
    <updated>2012-07-04T23:31:02+00:00</updated>
  </info>
  <style-options punctuation-in-quote="false"/>
  <date form="text">
    <date-part name="day" form="ordinal" suffix=" "/>
    <date-part name="month" suffix=" "/>
    <date-part name="year"/>
  </date>
  <date form="numeric">
    <date-part name="day" form="numeric-leading-zeros" suffix="."/>
    <date-part name="month" form="numeric-leading-zeros" suffix="."/>
    <date-part name="year"/>
  </date>
  <terms>
    <term name="accessed">zugegriffen</term>
    <term name="and">und</term>
    <term name="and others">und andere</term>
    <term name="anonymous">ohne Autor</term>
    <term name="anonymous" form="short">o.&#160;A.</term>
    <term name="at">auf</term>
    <term name="available at">verfügbar unter</term>
    <term name="by">von</term>
    <term name="circa">circa</term>
    <term name="circa" form="short">ca.</term>
    <term name="cited">zitiert</term>
    <term name="edition">
      <single>Auflage</single>
      <multiple>Auflagen</multiple>
    </term>
    <term name="edition" form="short">Aufl.</term>
    <term name="et-al">u.&#160;a.</term>
    <term name="forthcoming">i.&#160;E.</term>
    <term name="from">von</term>
    <term name="ibid">ebd.</term>
    <term name="in">in</term>
    <term name="in press">im Druck</term>
    <term name="internet">Internet</term>
    <term name="interview">Interview</term>
    <term name="letter">Brief</term>
    <term name="no date">ohne Datum</term>
    <term name="no date" form="short">o.&#160;J.</term>
    <term name="online">online</term>
    <term name="presented at">gehalten auf der</term>
    <term name="reference">
      <single>Referenz</single>
      <multiple>Referenzen</multiple>
    </term>
    <term name="reference" form="short">
      <single>Ref.</single>
      <multiple>Ref.</multiple>
    </term>
    <term name="retrieved">abgerufen</term>
    <term name="scale">Maßstab</term>
    <term name="version">Version</term>

    <!-- ANNO DOMINI; BEFORE CHRIST -->
    <term name="ad">&#160;n.&#160;Chr.</term>
    <term name="bc">&#160;v.&#160;Chr.</term>

    <!-- PUNCTUATION -->
    <term name="open-quote">„</term>
    <term name="close-quote">“</term>
    <term name="open-inner-quote">‚</term>
    <term name="close-inner-quote">‘</term>
    <term name="page-range-delimiter">–</term>

    <!-- ORDINALS -->
    <term name="ordinal">.</term>

    <!-- LONG ORDINALS -->
    <term name="long-ordinal-01">erster</term>
    <term name="long-ordinal-02">zweiter</term>
    <term name="long-ordinal-03">dritter</term>
    <term name="long-ordinal-04">vierter</term>
    <term name="long-ordinal-05">fünfter</term>
    <term name="long-ordinal-06">sechster</term>
    <term name="long-ordinal-07">siebter</term>
    <term name="long-ordinal-08">achter</term>
    <term name="long-ordinal-09">neunter</term>
    <term name="long-ordinal-10">zehnter</term>

    <!-- LONG LOCATOR FORMS -->
    <term name="book">
      <single>Buch</single>
      <multiple>Bücher</multiple>
    </term>
    <term name="chapter">
      <single>Kapitel</single>
      <multiple>Kapitel</multiple>
    </term>
    <term name="column">
      <single>Spalte</single>
      <multiple>Spalten</multiple>
    </term>
    <term name="figure">
      <single>Abbildung</single>
      <multiple>Abbildungen</multiple>
    </term>
    <term name="folio">
      <single>Blatt</single>
      <multiple>Blätter</multiple>
    </term>
    <term name="issue">
      <single>Nummer</single>
      <multiple>Nummern</multiple>
    </term>
    <term name="line">
      <single>Zeile</single>
      <multiple>Zeilen</multiple>
    </term>
    <term name="note">
      <single>Note</single>
      <multiple>Noten</multiple>
    </term>
    <term name="opus">
      <single>Opus</single>
      <multiple>Opera</multiple>
    </term>
    <term name="page">
      <single>Seite</single>
      <multiple>Seiten</multiple>
    </term>
    <term name="number-of-pages">
      <single>Seite</single>
      <multiple>Seiten</multiple>
    </term>
    <term name="paragraph">
      <single>Absatz</single>
      <multiple>Absätze</multiple>
    </term>
    <term name="part">
      <single>Teil</single>
      <multiple>Teile</multiple>
    </term>
    <term name="section">
      <single>Abschnitt</single>
      <multiple>Abschnitte</multiple>
    </term>
    <term name="sub verbo">
      <single>sub verbo</single>
      <multiple>sub verbis</multiple>
    </term>
    <term name="verse">
      <single>Vers</single>
      <multiple>Verse</multiple>
    </term>
    <term name="volume">
      <single>Band</single>
      <multiple>Bände</multiple>
    </term>

    <!-- SHORT LOCATOR FORMS -->
    <term name="book" form="short">B.</term>
    <term name="chapter" form="short">Kap.</term>
    <term name="column" form="short">Sp.</term>
    <term name="figure" form="short">Abb.</term>
    <term name="folio" form="short">Fol.</term>
    <term name="issue" form="short">Nr.</term>
    <term name="line" form="short">l.</term>
    <term name="note" form="short">n.</term>
    <term name="opus" form="short">op.</term>
    <term name="page" form="short">
      <single>S.</single>
      <multiple>S.</multiple>
    </term>
    <term name="number-of-pages" form="short">
      <single>S.</single>
      <multiple>S.</multiple>
    </term>
    <term name="paragraph" form="short">Abs.</term>
    <term name="part" form="short">Teil</term>
    <term name="section" form="short">Abschn.</term>
    <term name="sub verbo" form="short">
      <single>s.&#160;v.</single>
      <multiple>s.&#160;vv.</multiple>
    </term>
    <term name="verse" form="short">
      <single>V.</single>
      <multiple>V.</multiple>
    </term>
    <term name="volume" form="short">
      <single>Bd.</single>
      <multiple>Bd.</multiple>
    </term>

    <!-- SYMBOL LOCATOR FORMS -->
    <term name="paragraph" form="symbol">
      <single>¶</single>
      <multiple>¶¶</multiple>
    </term>
    <term name="section" form="symbol">
      <single>§</single>
      <multiple>§§</multiple>
    </term>

    <!-- LONG ROLE FORMS -->
    <term name="director">
      <single>Regisseur</single>
      <multiple>Regisseure</multiple>
    </term>
    <term name="editor">
      <single>Herausgeber</single>
      <multiple>Herausgeber</multiple>
    </term>
    <term name="collection-editor">
      <single>Reihenherausgeber</single>
      <multiple>Reihenherausgeber</multiple>
    </term>
    <term name="editorial-director">
      <single>Herausgeber</single>
      <multiple>Herausgeber</multiple>
    </term>
    <term name="illustrator">
      <single>Illustrator</single>
      <multiple>Illustratoren</multiple>
    </term>
    <term name="translator">
      <single>Übersetzer</single>
      <multiple>Übersetzer</multiple>
    </term>
    <term name="editortranslator">
      <single>Herausgeber&#160;&amp; Übersetzer</single>
      <multiple>Herausgeber&#160;&amp; Übersetzer</multiple>
    </term>

    <!-- SHORT ROLE FORMS -->
    <term name="director" form="short">
      <single>Reg.</single>
      <multiple>Reg.</multiple>
    </term>
    <term name="editor" form="short">
      <single>Hrsg.</single>
      <multiple>Hrsg.</multiple>
    </term>
    <term name="collection-editor" form="short">
      <single>Hrsg.</single>
      <multiple>Hrsg.</multiple>
    </term>
    <term name="editorial-director" form="short">
      <single>Hrsg.</single>
      <multiple>Hrsg.</multiple>
    </term>
    <term name="illustrator" form="short">
      <single>Ill.</single>
      <multiple>Ill.</multiple>
    </term>
    <term name="translator" form="short">
      <single>Übers.</single>
      <multiple>Übers.</multiple>
    </term>
    <term name="editortranslator" form="short">
      <single>Hrsg.&#160;&amp; Übers.</single>
      <multiple>Hrsg.&#160;&amp; Übers</multiple>
    </term>

    <!-- VERB ROLE FORMS -->
    <term name="container-author" form="verb">von</term>
    <term name="director" form="verb">Regie von</term>
    <term name="editor" form="verb">herausgegeben von</term>
    <term name="collection-editor" form="verb">herausgegeben von</term>
    <term name="editorial-director" form="verb">herausgegeben von</term>
    <term name="illustrator" form="verb">illustriert von</term>
    <term name="interviewer" form="verb">interviewt von</term>
    <term name="recipient" form="verb">an</term>
    <term name="reviewed-author" form="verb">von</term>
    <term name="translator" form="verb">übersetzt von</term>
    <term name="editortranslator" form="verb">herausgegeben und übersetzt von</term>

    <!-- SHORT VERB ROLE FORMS -->
    <term name="director" form="verb-short">Reg.</term>
    <term name="editor" form="verb-short">hg. von</term>
    <term name="collection-editor" form="verb-short">hg. von</term>
    <term name="editorial-director" form="verb-short">hg. von</term>
    <term name="illustrator" form="verb-short">illus. von</term>
    <term name="translator" form="verb-short">übers. von</term>
    <term name="editortranslator" form="verb-short">hg.&#160;&amp; übers. von</term>

    <!-- LONG MONTH FORMS -->
    <term name="month-01">Jänner</term>
    <term name="month-02">Februar</term>
    <term name="month-03">März</term>
    <term name="month-04">April</term>
    <term name="month-05">Mai</term>
    <term name="month-06">Juni</term>
    <term name="month-07">Juli</term>
    <term name="month-08">August</term>
    <term name="month-09">September</term>
    <term name="month-10">Oktober</term>
    <term name="month-11">November</term>
    <term name="month-12">Dezember</term>

    <!-- SHORT MONTH FORMS -->
    <term name="month-01" form="short">Jän.</term>
    <term name="month-02" form="short">Feb.</term>
    <term name="month-03" form="short">März</term>
    <term name="month-04" form="short">Apr.</term>
    <term name="month-05" form="short">Mai</term>
    <term name="month-06" form="short">Juni</term>
    <term name="month-07" form="short">Juli</term>
    <term name="month-08" form="short">Aug.</term>
    <term name="month-09" form="short">Sep.</term>
    <term name="month-10" form="short">Okt.</term>
    <term name="month-11" form="short">Nov.</term>
    <term name="month-12" form="short">Dez.</term>

    <!-- SEASONS -->
    <term name="season-01">Frühjahr</term>
    <term name="season-02">Sommer</term>
    <term name="season-03">Herbst</term>
    <term name="season-04">Winter</term>
  </terms>
</locale>`,
  "de-CH": `<?xml version="1.0" encoding="utf-8"?>
<locale xmlns="http://purl.org/net/xbiblio/csl" version="1.0" xml:lang="de-CH">
  <info>
    <translator>
      <name>Till A. Heilmann</name>
    </translator>
    <translator>
      <name>Sylvester Keil</name>
    </translator>
    <translator>
      <name>jakov</name>
    </translator>
    <translator>
      <name>Sebastian Karcher</name>
    </translator>
    <rights license="http://creativecommons.org/licenses/by-sa/3.0/">This work is licensed under a Creative Commons Attribution-ShareAlike 3.0 License</rights>
    <updated>2012-07-04T23:31:02+00:00</updated>
  </info>
  <style-options punctuation-in-quote="false"/>
  <date form="text">
    <date-part name="day" form="ordinal" suffix=" "/>
    <date-part name="month" suffix=" "/>
    <date-part name="year"/>
  </date>
  <date form="numeric">
    <date-part name="day" form="numeric-leading-zeros" suffix="."/>
    <date-part name="month" form="numeric-leading-zeros" suffix="."/>
    <date-part name="year"/>
  </date>
  <terms>
    <term name="accessed">zugegriffen</term>
    <term name="and">und</term>
    <term name="and others">und andere</term>
    <term name="anonymous">ohne Autor</term>
    <term name="anonymous" form="short">o.&#160;A.</term>
    <term name="at">auf</term>
    <term name="available at">verfügbar unter</term>
    <term name="by">von</term>
    <term name="circa">circa</term>
    <term name="circa" form="short">ca.</term>
    <term name="cited">zitiert</term>
    <term name="edition">
      <single>Auflage</single>
      <multiple>Auflagen</multiple>
    </term>
    <term name="edition" form="short">Aufl.</term>
    <term name="et-al">u.&#160;a.</term>
    <term name="forthcoming">i.&#160;E.</term>
    <term name="from">von</term>
    <term name="ibid">ebd.</term>
    <term name="in">in</term>
    <term name="in press">im Druck</term>
    <term name="internet">Internet</term>
    <term name="interview">Interview</term>
    <term name="letter">Brief</term>
    <term name="no date">ohne Datum</term>
    <term name="no date" form="short">o.&#160;J.</term>
    <term name="online">online</term>
    <term name="presented at">gehalten auf der</term>
    <term name="reference">
      <single>Referenz</single>
      <multiple>Referenzen</multiple>
    </term>
    <term name="reference" form="short">
      <single>Ref.</single>
      <multiple>Ref.</multiple>
    </term>
    <term name="retrieved">abgerufen</term>
    <term name="scale">Massstab</term>
    <term name="version">Version</term>

    <!-- ANNO DOMINI; BEFORE CHRIST -->
    <term name="ad">&#160;n.&#160;Chr.</term>
    <term name="bc">&#160;v.&#160;Chr.</term>

    <!-- PUNCTUATION -->
    <term name="open-quote">«</term>
    <term name="close-quote">»</term>
    <term name="open-inner-quote">‹</term>
    <term name="close-inner-quote">›</term>
    <term name="page-range-delimiter">–</term>

    <!-- ORDINALS -->
    <term name="ordinal">.</term>

    <!-- LONG ORDINALS -->
    <term name="long-ordinal-01">erster</term>
    <term name="long-ordinal-02">zweiter</term>
    <term name="long-ordinal-03">dritter</term>
    <term name="long-ordinal-04">vierter</term>
    <term name="long-ordinal-05">fünfter</term>
    <term name="long-ordinal-06">sechster</term>
    <term name="long-ordinal-07">siebter</term>
    <term name="long-ordinal-08">achter</term>
    <term name="long-ordinal-09">neunter</term>
    <term name="long-ordinal-10">zehnter</term>

    <!-- LONG LOCATOR FORMS -->
    <term name="book">
      <single>Buch</single>
      <multiple>Bücher</multiple>
    </term>
    <term name="chapter">
      <single>Kapitel</single>
      <multiple>Kapitel</multiple>
    </term>
    <term name="column">
      <single>Spalte</single>
      <multiple>Spalten</multiple>
    </term>
    <term name="figure">
      <single>Abbildung</single>
      <multiple>Abbildungen</multiple>
    </term>
    <term name="folio">
      <single>Blatt</single>
      <multiple>Blätter</multiple>
    </term>
    <term name="issue">
      <single>Nummer</single>
      <multiple>Nummern</multiple>
    </term>
    <term name="line">
      <single>Zeile</single>
      <multiple>Zeilen</multiple>
    </term>
    <term name="note">
      <single>Note</single>
      <multiple>Noten</multiple>
    </term>
    <term name="opus">
      <single>Opus</single>
      <multiple>Opera</multiple>
    </term>
    <term name="page">
      <single>Seite</single>
      <multiple>Seiten</multiple>
    </term>
    <term name="number-of-pages">
      <single>Seite</single>
      <multiple>Seiten</multiple>
    </term>
    <term name="paragraph">
      <single>Absatz</single>
      <multiple>Absätze</multiple>
    </term>
    <term name="part">
      <single>Teil</single>
      <multiple>Teile</multiple>
    </term>
    <term name="section">
      <single>Abschnitt</single>
      <multiple>Abschnitte</multiple>
    </term>
    <term name="sub verbo">
      <single>sub verbo</single>
      <multiple>sub verbis</multiple>
    </term>
    <term name="verse">
      <single>Vers</single>
      <multiple>Verse</multiple>
    </term>
    <term name="volume">
      <single>Band</single>
      <multiple>Bände</multiple>
    </term>

    <!-- SHORT LOCATOR FORMS -->
    <term name="book" form="short">B.</term>
    <term name="chapter" form="short">Kap.</term>
    <term name="column" form="short">Sp.</term>
    <term name="figure" form="short">Abb.</term>
    <term name="folio" form="short">Fol.</term>
    <term name="issue" form="short">Nr.</term>
    <term name="line" form="short">l.</term>
    <term name="note" form="short">n.</term>
    <term name="opus" form="short">op.</term>
    <term name="page" form="short">
      <single>S.</single>
      <multiple>S.</multiple>
    </term>
    <term name="number-of-pages" form="short">
      <single>S.</single>
      <multiple>S.</multiple>
    </term>
    <term name="paragraph" form="short">Abs.</term>
    <term name="part" form="short">Teil</term>
    <term name="section" form="short">Abschn.</term>
    <term name="sub verbo" form="short">
      <single>s.&#160;v.</single>
      <multiple>s.&#160;vv.</multiple>
    </term>
    <term name="verse" form="short">
      <single>V.</single>
      <multiple>V.</multiple>
    </term>
    <term name="volume" form="short">
      <single>Bd.</single>
      <multiple>Bd.</multiple>
    </term>

    <!-- SYMBOL LOCATOR FORMS -->
    <term name="paragraph" form="symbol">
      <single>¶</single>
      <multiple>¶¶</multiple>
    </term>
    <term name="section" form="symbol">
      <single>§</single>
      <multiple>§§</multiple>
    </term>

    <!-- LONG ROLE FORMS -->
    <term name="director">
      <single>Regisseur</single>
      <multiple>Regisseure</multiple>
    </term>
    <term name="editor">
      <single>Herausgeber</single>
      <multiple>Herausgeber</multiple>
    </term>
    <term name="editorial-director">
      <single>Herausgeber</single>
      <multiple>Herausgeber</multiple>
    </term>
    <term name="illustrator">
      <single>Illustrator</single>
      <multiple>Illustratoren</multiple>
    </term>
    <term name="translator">
      <single>Übersetzer</single>
      <multiple>Übersetzer</multiple>
    </term>
    <term name="editortranslator">
      <single>Herausgeber&#160;&amp; Übersetzer</single>
      <multiple>Herausgeber&#160;&amp; Übersetzer</multiple>
    </term>

    <!-- SHORT ROLE FORMS -->
    <term name="director" form="short">
      <single>Reg.</single>
      <multiple>Reg.</multiple>
    </term>
    <term name="editor" form="short">
      <single>Hrsg.</single>
      <multiple>Hrsg.</multiple>
    </term>
    <term name="editorial-director" form="short">
      <single>Hrsg.</single>
      <multiple>Hrsg.</multiple>
    </term>
    <term name="illustrator" form="short">
      <single>Ill.</single>
      <multiple>Ill.</multiple>
    </term>
    <term name="translator" form="short">
      <single>Übers.</single>
      <multiple>Übers.</multiple>
    </term>
    <term name="editortranslator" form="short">
      <single>Hrsg.&#160;&amp; Übers.</single>
      <multiple>Hrsg.&#160;&amp; Übers</multiple>
    </term>

    <!-- VERB ROLE FORMS -->
    <term name="container-author" form="verb">von</term>
    <term name="director" form="verb">Regie von</term>
    <term name="editor" form="verb">herausgegeben von</term>
    <term name="editorial-director" form="verb">herausgegeben von</term>
    <term name="illustrator" form="verb">illustriert von</term>
    <term name="interviewer" form="verb">interviewt von</term>
    <term name="recipient" form="verb">an</term>
    <term name="reviewed-author" form="verb">von</term>
    <term name="translator" form="verb">übersetzt von</term>
    <term name="editortranslator" form="verb">herausgegeben und übersetzt von</term>

    <!-- SHORT VERB ROLE FORMS -->
    <term name="director" form="verb-short">Reg.</term>
    <term name="editor" form="verb-short">hg. von</term>
    <term name="editorial-director" form="verb-short">hg. von</term>
    <term name="illustrator" form="verb-short">illus. von</term>
    <term name="translator" form="verb-short">übers. von</term>
    <term name="editortranslator" form="verb-short">hg.&#160;&amp; übers. von</term>

    <!-- LONG MONTH FORMS -->
    <term name="month-01">Januar</term>
    <term name="month-02">Februar</term>
    <term name="month-03">März</term>
    <term name="month-04">April</term>
    <term name="month-05">Mai</term>
    <term name="month-06">Juni</term>
    <term name="month-07">Juli</term>
    <term name="month-08">August</term>
    <term name="month-09">September</term>
    <term name="month-10">Oktober</term>
    <term name="month-11">November</term>
    <term name="month-12">Dezember</term>

    <!-- SHORT MONTH FORMS -->
    <term name="month-01" form="short">Jan.</term>
    <term name="month-02" form="short">Feb.</term>
    <term name="month-03" form="short">März</term>
    <term name="month-04" form="short">Apr.</term>
    <term name="month-05" form="short">Mai</term>
    <term name="month-06" form="short">Juni</term>
    <term name="month-07" form="short">Juli</term>
    <term name="month-08" form="short">Aug.</term>
    <term name="month-09" form="short">Sep.</term>
    <term name="month-10" form="short">Okt.</term>
    <term name="month-11" form="short">Nov.</term>
    <term name="month-12" form="short">Dez.</term>

    <!-- SEASONS -->
    <term name="season-01">Frühjahr</term>
    <term name="season-02">Sommer</term>
    <term name="season-03">Herbst</term>
    <term name="season-04">Winter</term>
  </terms>
</locale>`,
  "de-DE": `<?xml version="1.0" encoding="utf-8"?>
<locale xmlns="http://purl.org/net/xbiblio/csl" version="1.0" xml:lang="de-DE">
  <info>
    <translator>
      <name>Till A. Heilmann</name>
    </translator>
    <translator>
      <name>Ulrich</name>
    </translator>
    <translator>
      <name>Rintze M. Zelle</name>
    </translator>
    <translator>
      <name>Sebastian Karcher</name>
    </translator>
    <translator>
      <name>jakov</name>
    </translator>
    <rights license="http://creativecommons.org/licenses/by-sa/3.0/">This work is licensed under a Creative Commons Attribution-ShareAlike 3.0 License</rights>
    <updated>2012-07-04T23:31:02+00:00</updated>
  </info>
  <style-options punctuation-in-quote="false"/>
  <date form="text">
    <date-part name="day" form="ordinal" suffix=" "/>
    <date-part name="month" suffix=" "/>
    <date-part name="year"/>
  </date>
  <date form="numeric">
    <date-part name="day" form="numeric-leading-zeros" suffix="."/>
    <date-part name="month" form="numeric-leading-zeros" suffix="."/>
    <date-part name="year"/>
  </date>
  <terms>
    <term name="accessed">zugegriffen</term>
    <term name="and">und</term>
    <term name="and others">und andere</term>
    <term name="anonymous">ohne Autor</term>
    <term name="anonymous" form="short">o.&#160;A.</term>
    <term name="at">auf</term>
    <term name="available at">verfügbar unter</term>
    <term name="by">von</term>
    <term name="circa">circa</term>
    <term name="circa" form="short">ca.</term>
    <term name="cited">zitiert</term>
    <term name="edition">
      <single>Auflage</single>
      <multiple>Auflagen</multiple>
    </term>
    <term name="edition" form="short">Aufl.</term>
    <term name="et-al">u.&#160;a.</term>
    <term name="forthcoming">i.&#160;E.</term>
    <term name="from">von</term>
    <term name="ibid">ebd.</term>
    <term name="in">in</term>
    <term name="in press">im Druck</term>
    <term name="internet">Internet</term>
    <term name="interview">Interview</term>
    <term name="letter">Brief</term>
    <term name="no date">ohne Datum</term>
    <term name="no date" form="short">o.&#160;J.</term>
    <term name="online">online</term>
    <term name="presented at">gehalten auf der</term>
    <term name="reference">
      <single>Referenz</single>
      <multiple>Referenzen</multiple>
    </term>
    <term name="reference" form="short">
      <single>Ref.</single>
      <multiple>Ref.</multiple>
    </term>
    <term name="retrieved">abgerufen</term>
    <term name="scale">Maßstab</term>
    <term name="version">Version</term>

    <!-- ANNO DOMINI; BEFORE CHRIST -->
    <term name="ad">&#160;n.&#160;Chr.</term>
    <term name="bc">&#160;v.&#160;Chr.</term>

    <!-- PUNCTUATION -->
    <term name="open-quote">„</term>
    <term name="close-quote">“</term>
    <term name="open-inner-quote">‚</term>
    <term name="close-inner-quote">‘</term>
    <term name="page-range-delimiter">–</term>

    <!-- ORDINALS -->
    <term name="ordinal">.</term>

    <!-- LONG ORDINALS -->
    <term name="long-ordinal-01">erster</term>
    <term name="long-ordinal-02">zweiter</term>
    <term name="long-ordinal-03">dritter</term>
    <term name="long-ordinal-04">vierter</term>
    <term name="long-ordinal-05">fünfter</term>
    <term name="long-ordinal-06">sechster</term>
    <term name="long-ordinal-07">siebter</term>
    <term name="long-ordinal-08">achter</term>
    <term name="long-ordinal-09">neunter</term>
    <term name="long-ordinal-10">zehnter</term>

    <!-- LONG LOCATOR FORMS -->
    <term name="book">
      <single>Buch</single>
      <multiple>Bücher</multiple>
    </term>
    <term name="chapter">
      <single>Kapitel</single>
      <multiple>Kapitel</multiple>
    </term>
    <term name="column">
      <single>Spalte</single>
      <multiple>Spalten</multiple>
    </term>
    <term name="figure">
      <single>Abbildung</single>
      <multiple>Abbildungen</multiple>
    </term>
    <term name="folio">
      <single>Blatt</single>
      <multiple>Blätter</multiple>
    </term>
    <term name="issue">
      <single>Nummer</single>
      <multiple>Nummern</multiple>
    </term>
    <term name="line">
      <single>Zeile</single>
      <multiple>Zeilen</multiple>
    </term>
    <term name="note">
      <single>Note</single>
      <multiple>Noten</multiple>
    </term>
    <term name="opus">
      <single>Opus</single>
      <multiple>Opera</multiple>
    </term>
    <term name="page">
      <single>Seite</single>
      <multiple>Seiten</multiple>
    </term>
    <term name="number-of-pages">
      <single>Seite</single>
      <multiple>Seiten</multiple>
    </term>
    <term name="paragraph">
      <single>Absatz</single>
      <multiple>Absätze</multiple>
    </term>
    <term name="part">
      <single>Teil</single>
      <multiple>Teile</multiple>
    </term>
    <term name="section">
      <single>Abschnitt</single>
      <multiple>Abschnitte</multiple>
    </term>
    <term name="sub verbo">
      <single>sub verbo</single>
      <multiple>sub verbis</multiple>
    </term>
    <term name="verse">
      <single>Vers</single>
      <multiple>Verse</multiple>
    </term>
    <term name="volume">
      <single>Band</single>
      <multiple>Bände</multiple>
    </term>

    <!-- SHORT LOCATOR FORMS -->
    <term name="book" form="short">B.</term>
    <term name="chapter" form="short">Kap.</term>
    <term name="column" form="short">Sp.</term>
    <term name="figure" form="short">Abb.</term>
    <term name="folio" form="short">Fol.</term>
    <term name="issue" form="short">Nr.</term>
    <term name="line" form="short">Z.</term>
    <term name="note" form="short">N.</term>
    <term name="opus" form="short">op.</term>
    <term name="page" form="short">
      <single>S.</single>
      <multiple>S.</multiple>
    </term>
    <term name="number-of-pages" form="short">
      <single>S.</single>
      <multiple>S.</multiple>
    </term>
    <term name="paragraph" form="short">Abs.</term>
    <term name="part" form="short">Teil</term>
    <term name="section" form="short">Abschn.</term>
    <term name="sub verbo" form="short">
      <single>s.&#160;v.</single>
      <multiple>s.&#160;vv.</multiple>
    </term>
    <term name="verse" form="short">
      <single>V.</single>
      <multiple>V.</multiple>
    </term>
    <term name="volume" form="short">
      <single>Bd.</single>
      <multiple>Bde.</multiple>
    </term>

    <!-- SYMBOL LOCATOR FORMS -->
    <term name="paragraph" form="symbol">
      <single>¶</single>
      <multiple>¶¶</multiple>
    </term>
    <term name="section" form="symbol">
      <single>§</single>
      <multiple>§§</multiple>
    </term>

    <!-- LONG ROLE FORMS -->
    <term name="director">
      <single>Regisseur</single>
      <multiple>Regisseure</multiple>
    </term>
    <term name="editor">
      <single>Herausgeber</single>
      <multiple>Herausgeber</multiple>
    </term>
    <term name="collection-editor">
      <single>Reihenherausgeber</single>
      <multiple>Reihenherausgeber</multiple>
    </term>
    <term name="editorial-director">
      <single>Herausgeber</single>
      <multiple>Herausgeber</multiple>
    </term>
    <term name="illustrator">
      <single>Illustrator</single>
      <multiple>Illustratoren</multiple>
    </term>
    <term name="translator">
      <single>Übersetzer</single>
      <multiple>Übersetzer</multiple>
    </term>
    <term name="editortranslator">
      <single>Herausgeber&#160;&amp; Übersetzer</single>
      <multiple>Herausgeber&#160;&amp; Übersetzer</multiple>
    </term>

    <!-- SHORT ROLE FORMS -->
    <term name="director" form="short">
      <single>Reg.</single>
      <multiple>Reg.</multiple>
    </term>
    <term name="editor" form="short">
      <single>Hrsg.</single>
      <multiple>Hrsg.</multiple>
    </term>
    <term name="collection-editor" form="short">
      <single>Hrsg.</single>
      <multiple>Hrsg.</multiple>
    </term>
    <term name="editorial-director" form="short">
      <single>Hrsg.</single>
      <multiple>Hrsg.</multiple>
    </term>
    <term name="illustrator" form="short">
      <single>Ill.</single>
      <multiple>Ill.</multiple>
    </term>
    <term name="translator" form="short">
      <single>Übers.</single>
      <multiple>Übers.</multiple>
    </term>
    <term name="editortranslator" form="short">
      <single>Hrsg.&#160;&amp; Übers.</single>
      <multiple>Hrsg.&#160;&amp; Übers</multiple>
    </term>

    <!-- VERB ROLE FORMS -->
    <term name="container-author" form="verb">von</term>
    <term name="director" form="verb">Regie von</term>
    <term name="editor" form="verb">herausgegeben von</term>
    <term name="collection-editor" form="verb">herausgegeben von</term>
    <term name="editorial-director" form="verb">herausgegeben von</term>
    <term name="illustrator" form="verb">illustriert von</term>
    <term name="interviewer" form="verb">interviewt von</term>
    <term name="recipient" form="verb">an</term>
    <term name="reviewed-author" form="verb">von</term>
    <term name="translator" form="verb">übersetzt von</term>
    <term name="editortranslator" form="verb">herausgegeben und übersetzt von</term>

    <!-- SHORT VERB ROLE FORMS -->
    <term name="director" form="verb-short">Reg.</term>
    <term name="editor" form="verb-short">hg. von</term>
    <term name="collection-editor" form="verb-short">hg. von</term>
    <term name="editorial-director" form="verb-short">hg. von</term>
    <term name="illustrator" form="verb-short">illus. von</term>
    <term name="translator" form="verb-short">übers. von</term>
    <term name="editortranslator" form="verb-short">hg.&#160;&amp; übers. von</term>

    <!-- LONG MONTH FORMS -->
    <term name="month-01">Januar</term>
    <term name="month-02">Februar</term>
    <term name="month-03">März</term>
    <term name="month-04">April</term>
    <term name="month-05">Mai</term>
    <term name="month-06">Juni</term>
    <term name="month-07">Juli</term>
    <term name="month-08">August</term>
    <term name="month-09">September</term>
    <term name="month-10">Oktober</term>
    <term name="month-11">November</term>
    <term name="month-12">Dezember</term>

    <!-- SHORT MONTH FORMS -->
    <term name="month-01" form="short">Jan.</term>
    <term name="month-02" form="short">Feb.</term>
    <term name="month-03" form="short">März</term>
    <term name="month-04" form="short">Apr.</term>
    <term name="month-05" form="short">Mai</term>
    <term name="month-06" form="short">Juni</term>
    <term name="month-07" form="short">Juli</term>
    <term name="month-08" form="short">Aug.</term>
    <term name="month-09" form="short">Sep.</term>
    <term name="month-10" form="short">Okt.</term>
    <term name="month-11" form="short">Nov.</term>
    <term name="month-12" form="short">Dez.</term>

    <!-- SEASONS -->
    <term name="season-01">Frühjahr</term>
    <term name="season-02">Sommer</term>
    <term name="season-03">Herbst</term>
    <term name="season-04">Winter</term>
  </terms>
</locale>`,
  "es-ES": `<?xml version="1.0" encoding="utf-8"?>
<locale xmlns="http://purl.org/net/xbiblio/csl" version="1.0" xml:lang="es-ES">
  <info>
    <translator>
      <name>javimat</name>
    </translator>
    <rights license="http://creativecommons.org/licenses/by-sa/3.0/">This work is licensed under a Creative Commons Attribution-ShareAlike 3.0 License</rights>
    <updated>2012-07-04T23:31:02+00:00</updated>
  </info>
  <style-options punctuation-in-quote="false"/>
  <date form="text">
    <date-part name="day" suffix=" de "/>
    <date-part name="month" suffix=" de "/>
    <date-part name="year"/>
  </date>
  <date form="numeric">
    <date-part name="day" form="numeric-leading-zeros" suffix="/"/>
    <date-part name="month" form="numeric-leading-zeros" suffix="/"/>
    <date-part name="year"/>
  </date>
  <terms>
    <term name="accessed">accedido</term>
    <term name="and">y</term>
    <term name="and others">y otros</term>
    <term name="anonymous">anónimo</term>
    <term name="anonymous" form="short">anón.</term>
    <term name="at">en</term>
    <term name="available at">disponible en</term>
    <term name="by">de</term>
    <term name="circa">circa</term>
    <term name="circa" form="short">c.</term>
    <term name="cited">citado</term>
    <term name="edition">
      <single>edición</single>
      <multiple>ediciones</multiple>
    </term>
    <term name="edition" form="short">ed.</term>
    <term name="et-al">et&#160;al.</term>
    <term name="forthcoming">previsto</term>
    <term name="from">a partir de</term>
    <term name="ibid">ibid.</term>
    <term name="in">en</term>
    <term name="in press">en imprenta</term>
    <term name="internet">internet</term>
    <term name="interview">entrevista</term>
    <term name="letter">carta</term>
    <term name="no date">sin fecha</term>
    <term name="no date" form="short">s.&#160;f.</term>
    <term name="online">en línea</term>
    <term name="presented at">presentado en</term>
    <term name="reference">
      <single>referencia</single>
      <multiple>referencias</multiple>
    </term>
    <term name="reference" form="short">
      <single>ref.</single>
      <multiple>refs.</multiple>
    </term>
    <term name="retrieved">recuperado</term>
    <term name="scale">escala</term>
    <term name="version">versión</term>

    <!-- ANNO DOMINI; BEFORE CHRIST -->
    <term name="ad">d.&#160;C.</term>
    <term name="bc">a.&#160;C.</term>

    <!-- PUNCTUATION -->
    <term name="open-quote">«</term>
    <term name="close-quote">»</term>
    <term name="open-inner-quote">“</term>
    <term name="close-inner-quote">”</term>
    <term name="page-range-delimiter">-</term>

    <!-- ORDINALS -->
    <term name="ordinal">.ª</term>

    <!-- LONG ORDINALS -->
    <term name="long-ordinal-01">primera</term>
    <term name="long-ordinal-02">segunda</term>
    <term name="long-ordinal-03">tercera</term>
    <term name="long-ordinal-04">cuarta</term>
    <term name="long-ordinal-05">quinta</term>
    <term name="long-ordinal-06">sexta</term>
    <term name="long-ordinal-07">séptima</term>
    <term name="long-ordinal-08">octava</term>
    <term name="long-ordinal-09">novena</term>
    <term name="long-ordinal-10">décima</term>

    <!-- LONG LOCATOR FORMS -->
    <term name="book">
      <single>libro</single>
      <multiple>libros</multiple>
    </term>
    <term name="chapter">
      <single>capítulo</single>
      <multiple>capítulos</multiple>
    </term>
    <term name="column">
      <single>columna</single>
      <multiple>columnas</multiple>
    </term>
    <term name="figure">
      <single>figura</single>
      <multiple>figuras</multiple>
    </term>
    <term name="folio">
      <single>folio</single>
      <multiple>folios</multiple>
    </term>
    <term name="issue">
      <single>número</single>
      <multiple>números</multiple>
    </term>
    <term name="line">
      <single>línea</single>
      <multiple>líneas</multiple>
    </term>
    <term name="note">
      <single>nota</single>
      <multiple>notas</multiple>
    </term>
    <term name="opus">
      <single>opus</single>
      <multiple>opera</multiple>
    </term>
    <term name="page">
      <single>página</single>
      <multiple>páginas</multiple>
    </term>
    <term name="number-of-pages">
      <single>página</single>
      <multiple>páginas</multiple>
    </term>
    <term name="paragraph">
      <single>párrafo</single>
      <multiple>párrafos</multiple>
    </term>
    <term name="part">
      <single>parte</single>
      <multiple>partes</multiple>
    </term>
    <term name="section">
      <single>sección</single>
      <multiple>secciones</multiple>
    </term>
    <term name="sub verbo">
      <single>sub voce</single>
      <multiple>sub vocibus</multiple>
    </term>
    <term name="verse">
      <single>verso</single>
      <multiple>versos</multiple>
    </term>
    <term name="volume">
      <single>volumen</single>
      <multiple>volúmenes</multiple>
    </term>

    <!-- SHORT LOCATOR FORMS -->
    <term name="book" form="short">lib.</term>
    <term name="chapter" form="short">cap.</term>
    <term name="column" form="short">col.</term>
    <term name="figure" form="short">fig.</term>
    <term name="folio" form="short">f.</term>
    <term name="issue" form="short">n.º</term>
    <term name="line" form="short">l.</term>
    <term name="note" form="short">n.</term>
    <term name="opus" form="short">op.</term>
    <term name="page" form="short">
      <single>p.</single>
      <multiple>pp.</multiple>
    </term>
    <term name="number-of-pages" form="short">
      <single>p.</single>
      <multiple>pp.</multiple>
    </term>
    <term name="paragraph" form="short">párr.</term>
    <term name="part" form="short">pt.</term>
    <term name="section" form="short">sec.</term>
    <term name="sub verbo" form="short">
      <single>s.&#160;v.</single>
      <multiple>s.&#160;vv.</multiple>
    </term>
    <term name="verse" form="short">
      <single>v.</single>
      <multiple>vv.</multiple>
    </term>
    <term name="volume" form="short">
      <single>vol.</single>
      <multiple>vols.</multiple>
    </term>

    <!-- SYMBOL LOCATOR FORMS -->
    <term name="paragraph" form="symbol">
      <single>§</single>
      <multiple>§</multiple>
    </term>
    <term name="section" form="symbol">
      <single>§</single>
      <multiple>§</multiple>
    </term>

    <!-- LONG ROLE FORMS -->
    <term name="director">
      <single>director</single>
      <multiple>directores</multiple>
    </term>
    <term name="editor">
      <single>editor</single>
      <multiple>editores</multiple>
    </term>
    <term name="editorial-director">
      <single>editor</single>
      <multiple>editores</multiple>
    </term>
    <term name="illustrator">
      <single>ilustrador</single>
      <multiple>ilustradores</multiple>
    </term>
    <term name="translator">
      <single>traductor</single>
      <multiple>traductores</multiple>
    </term>
    <term name="editortranslator">
      <single>editor y traductor</single>
      <multiple>editores y traductores</multiple>
    </term>

    <!-- SHORT ROLE FORMS -->
    <term name="director" form="short">
      <single>dir.</single>
      <multiple>dirs.</multiple>
    </term>
    <term name="editor" form="short">
      <single>ed.</single>
      <multiple>eds.</multiple>
    </term>
    <term name="editorial-director" form="short">
      <single>ed.</single>
      <multiple>eds.</multiple>
    </term>
    <term name="illustrator" form="short">
      <single>ilust.</single>
      <multiple>ilusts.</multiple>
    </term>
    <term name="translator" form="short">
      <single>trad.</single>
      <multiple>trads.</multiple>
    </term>
    <term name="editortranslator" form="short">
      <single>ed. y trad.</single>
      <multiple>eds. y trads.</multiple>
    </term>

    <!-- VERB ROLE FORMS -->
    <term name="container-author" form="verb">de</term>
    <term name="director" form="verb">dirigido por</term>
    <term name="editor" form="verb">editado por</term>
    <term name="editorial-director" form="verb">editado por</term>
    <term name="illustrator" form="verb">ilustrado por</term>
    <term name="interviewer" form="verb">entrevistado por</term>
    <term name="recipient" form="verb">a</term>
    <term name="reviewed-author" form="verb">por</term>
    <term name="translator" form="verb">traducido por</term>
    <term name="editortranslator" form="verb">editado y traducido por</term>

    <!-- SHORT VERB ROLE FORMS -->
    <term name="director" form="verb-short">dir.</term>
    <term name="editor" form="verb-short">ed.</term>
    <term name="editorial-director" form="verb-short">ed.</term>
    <term name="illustrator" form="verb-short">ilust.</term>
    <term name="translator" form="verb-short">trad.</term>
    <term name="editortranslator" form="verb-short">ed. y trad.</term>

    <!-- LONG MONTH FORMS -->
    <term name="month-01">enero</term>
    <term name="month-02">febrero</term>
    <term name="month-03">marzo</term>
    <term name="month-04">abril</term>
    <term name="month-05">mayo</term>
    <term name="month-06">junio</term>
    <term name="month-07">julio</term>
    <term name="month-08">agosto</term>
    <term name="month-09">septiembre</term>
    <term name="month-10">octubre</term>
    <term name="month-11">noviembre</term>
    <term name="month-12">diciembre</term>

    <!-- SHORT MONTH FORMS -->
    <term name="month-01" form="short">ene.</term>
    <term name="month-02" form="short">feb.</term>
    <term name="month-03" form="short">mar.</term>
    <term name="month-04" form="short">abr.</term>
    <term name="month-05" form="short">may</term>
    <term name="month-06" form="short">jun.</term>
    <term name="month-07" form="short">jul.</term>
    <term name="month-08" form="short">ago.</term>
    <term name="month-09" form="short">sep.</term>
    <term name="month-10" form="short">oct.</term>
    <term name="month-11" form="short">nov.</term>
    <term name="month-12" form="short">dic.</term>

    <!-- SEASONS -->
    <term name="season-01">primavera</term>
    <term name="season-02">verano</term>
    <term name="season-03">otoño</term>
    <term name="season-04">invierno</term>
  </terms>
</locale>`,
  "fr-FR": `<?xml version="1.0" encoding="utf-8"?>
<locale xmlns="http://purl.org/net/xbiblio/csl" version="1.0" xml:lang="fr-FR">
  <info>
    <translator>
      <name>Grégoire Colly</name>
    </translator>
    <rights license="http://creativecommons.org/licenses/by-sa/3.0/">This work is licensed under a Creative Commons Attribution-ShareAlike 3.0 License</rights>
    <updated>2012-07-04T23:31:02+00:00</updated>
  </info>
  <style-options punctuation-in-quote="false" limit-day-ordinals-to-day-1="true"/>
  <date form="text">
    <date-part name="day" suffix=" "/>
    <date-part name="month" suffix=" "/>
    <date-part name="year"/>
  </date>
  <date form="numeric">
    <date-part name="day" form="numeric-leading-zeros" suffix="/"/>
    <date-part name="month" form="numeric-leading-zeros" suffix="/"/>
    <date-part name="year"/>
  </date>
  <terms>
    <term name="accessed">consulté le</term>
    <term name="and">et</term>
    <term name="and others">et autres</term>
    <term name="anonymous">anonyme</term>
    <term name="anonymous" form="short">anon.</term>
    <term name="at">sur</term>
    <term name="available at">disponible sur</term>
    <term name="by">par</term>
    <term name="circa">vers</term>
    <term name="circa" form="short">v.</term>
    <term name="cited">cité</term>
    <term name="edition" gender="feminine">
      <single>édition</single>
      <multiple>éditions</multiple>
    </term>
    <term name="edition" form="short">éd.</term>
    <term name="et-al">et al.</term>
    <term name="forthcoming">à paraître</term>
    <term name="from">à l'adresse</term>
    <term name="ibid">ibid.</term>
    <term name="in">in</term>
    <term name="in press">sous presse</term>
    <term name="internet">Internet</term>
    <term name="interview">entretien</term>
    <term name="letter">lettre</term>
    <term name="no date">sans date</term>
    <term name="no date" form="short">s.&#160;d.</term>
    <term name="online">en ligne</term>
    <term name="presented at">présenté à</term>
    <term name="reference">
      <single>référence</single>
      <multiple>références</multiple>
    </term>
    <term name="reference" form="short">
      <single>réf.</single>
      <multiple>réf.</multiple>
    </term>
    <term name="retrieved">consulté</term>
    <term name="scale">échelle</term>
    <term name="version">version</term>

    <!-- ANNO DOMINI; BEFORE CHRIST -->
    <term name="ad">apr. J.-C.</term>
    <term name="bc">av. J.-C.</term>

    <!-- PUNCTUATION -->
    <term name="open-quote">«&#160;</term>
    <term name="close-quote">&#160;»</term>
    <term name="open-inner-quote">“</term>
    <term name="close-inner-quote">”</term>
    <term name="page-range-delimiter">&#8209;</term> <!-- non-breaking hyphen -->

    <!-- ORDINALS -->
    <term name="ordinal">ᵉ</term>
    <term name="ordinal-01" gender-form="feminine" match="whole-number">ʳᵉ</term>
    <term name="ordinal-01" gender-form="masculine" match="whole-number">ᵉʳ</term>
    
    <!-- LONG ORDINALS -->
    <term name="long-ordinal-01">premier</term>
    <term name="long-ordinal-02">deuxième</term>
    <term name="long-ordinal-03">troisième</term>
    <term name="long-ordinal-04">quatrième</term>
    <term name="long-ordinal-05">cinquième</term>
    <term name="long-ordinal-06">sixième</term>
    <term name="long-ordinal-07">septième</term>
    <term name="long-ordinal-08">huitième</term>
    <term name="long-ordinal-09">neuvième</term>
    <term name="long-ordinal-10">dixième</term>

    <!-- LONG LOCATOR FORMS -->
    <term name="book">
      <single>livre</single>
      <multiple>livres</multiple>
    </term>
    <term name="chapter">
      <single>chapitre</single>
      <multiple>chapitres</multiple>
    </term>
    <term name="column">
      <single>colonne</single>
      <multiple>colonnes</multiple>
    </term>
    <term name="figure">
      <single>figure</single>
      <multiple>figures</multiple>
    </term>
    <term name="folio">
      <single>folio</single>
      <multiple>folios</multiple>
    </term>
    <term name="issue" gender="masculine">
      <single>numéro</single>
      <multiple>numéros</multiple>
    </term>
    <term name="line">
      <single>ligne</single>
      <multiple>lignes</multiple>
    </term>
    <term name="note">
      <single>note</single>
      <multiple>notes</multiple>
    </term>
    <term name="opus">
      <single>opus</single>
      <multiple>opus</multiple>
    </term>
    <term name="page">
      <single>page</single>
      <multiple>pages</multiple>
    </term>
    <term name="number-of-pages">
      <single>page</single>
      <multiple>pages</multiple>
    </term>
    <term name="paragraph">
      <single>paragraphe</single>
      <multiple>paragraphes</multiple>
    </term>
    <term name="part">
      <single>partie</single>
      <multiple>parties</multiple>
    </term>
    <term name="section">
      <single>section</single>
      <multiple>sections</multiple>
    </term>
    <term name="sub verbo">
      <single>sub verbo</single>
      <multiple>sub verbis</multiple>
    </term>
    <term name="verse">
      <single>verset</single>
      <multiple>versets</multiple>
    </term>
    <term name="volume" gender="masculine">
      <single>volume</single>
      <multiple>volumes</multiple>
    </term>

    <!-- SHORT LOCATOR FORMS -->
    <term name="book" form="short">liv.</term>
    <term name="chapter" form="short">chap.</term>
    <term name="column" form="short">col.</term>
    <term name="figure" form="short">fig.</term>
    <term name="folio" form="short">
      <single>fᵒ</single>
      <multiple>fᵒˢ</multiple>
    </term>
    <term name="issue" form="short">
      <single>nᵒ</single>
      <multiple>nᵒˢ</multiple>
    </term>
    <term name="line" form="short">l.</term>
    <term name="note" form="short">n.</term>
    <term name="opus" form="short">op.</term>
    <term name="page" form="short">
      <single>p.</single>
      <multiple>p.</multiple>
    </term>
    <term name="number-of-pages" form="short">
      <single>p.</single>
      <multiple>p.</multiple>
    </term>
    <term name="paragraph" form="short">paragr.</term>
    <term name="part" form="short">part.</term>
    <term name="section" form="short">sect.</term>
    <term name="sub verbo" form="short">
      <single>s.&#160;v.</single>
      <multiple>s.&#160;vv.</multiple>
    </term>
    <term name="verse" form="short">
      <single>v.</single>
      <multiple>v.</multiple>
    </term>
    <term name="volume" form="short">
      <single>vol.</single>
      <multiple>vol.</multiple>
    </term>

    <!-- SYMBOL LOCATOR FORMS -->
    <term name="paragraph" form="symbol">
      <single>§</single>
      <multiple>§</multiple>
    </term>
    <term name="section" form="symbol">
      <single>§</single>
      <multiple>§</multiple>
    </term>

    <!-- LONG ROLE FORMS -->
    <term name="director">
      <single>réalisateur</single>
      <multiple>réalisateurs</multiple>
    </term>
    <term name="editor">
      <single>éditeur</single>
      <multiple>éditeurs</multiple>
    </term>
    <term name="editorial-director">
      <single>directeur</single>
      <multiple>directeurs</multiple>
    </term>
    <term name="illustrator">
      <single>illustrateur</single>
      <multiple>illustrateurs</multiple>
    </term>
    <term name="translator">
      <single>traducteur</single>
      <multiple>traducteurs</multiple>
    </term>
    <term name="editortranslator">
      <single>éditeur et traducteur</single>
      <multiple>éditeurs et traducteurs</multiple>
    </term>

    <!-- SHORT ROLE FORMS -->
    <term name="director" form="short">
      <single>réal.</single>
      <multiple>réal.</multiple>
    </term>
    <term name="editor" form="short">
      <single>éd.</single>
      <multiple>éd.</multiple>
    </term>
    <term name="editorial-director" form="short">
      <single>dir.</single>
      <multiple>dir.</multiple>
    </term>
    <term name="illustrator" form="short">
      <single>ill.</single>
      <multiple>ill.</multiple>
    </term>
    <term name="translator" form="short">
      <single>trad.</single>
      <multiple>trad.</multiple>
    </term>
    <term name="editortranslator" form="short">
      <single>éd. et trad.</single>
      <multiple>éd. et trad.</multiple>
    </term>

    <!-- VERB ROLE FORMS -->
    <term name="container-author" form="verb">par</term>
    <term name="director" form="verb">réalisé par</term>
    <term name="editor" form="verb">édité par</term>
    <term name="editorial-director" form="verb">sous la direction de</term>
    <term name="illustrator" form="verb">illustré par</term>
    <term name="interviewer" form="verb">entretien réalisé par</term>
    <term name="recipient" form="verb">à</term>
    <term name="reviewed-author" form="verb">par</term>
    <term name="translator" form="verb">traduit par</term>
    <term name="editortranslator" form="verb">édité et traduit par</term>

    <!-- SHORT VERB ROLE FORMS -->
    <term name="director" form="verb-short">réal. par</term>
    <term name="editor" form="verb-short">éd. par</term>
    <term name="editorial-director" form="verb-short">ss la dir. de</term>
    <term name="illustrator" form="verb-short">ill. par</term>
    <term name="translator" form="verb-short">trad. par</term>
    <term name="editortranslator" form="verb-short">éd. et trad. par</term>

    <!-- LONG MONTH FORMS -->
    <term name="month-01" gender="masculine">janvier</term>
    <term name="month-02" gender="masculine">février</term>
    <term name="month-03" gender="masculine">mars</term>
    <term name="month-04" gender="masculine">avril</term>
    <term name="month-05" gender="masculine">mai</term>
    <term name="month-06" gender="masculine">juin</term>
    <term name="month-07" gender="masculine">juillet</term>
    <term name="month-08" gender="masculine">août</term>
    <term name="month-09" gender="masculine">septembre</term>
    <term name="month-10" gender="masculine">octobre</term>
    <term name="month-11" gender="masculine">novembre</term>
    <term name="month-12" gender="masculine">décembre</term>

    <!-- SHORT MONTH FORMS -->
    <term name="month-01" form="short">janv.</term>
    <term name="month-02" form="short">févr.</term>
    <term name="month-03" form="short">mars</term>
    <term name="month-04" form="short">avr.</term>
    <term name="month-05" form="short">mai</term>
    <term name="month-06" form="short">juin</term>
    <term name="month-07" form="short">juill.</term>
    <term name="month-08" form="short">août</term>
    <term name="month-09" form="short">sept.</term>
    <term name="month-10" form="short">oct.</term>
    <term name="month-11" form="short">nov.</term>
    <term name="month-12" form="short">déc.</term>

    <!-- SEASONS -->
    <term name="season-01">printemps</term>
    <term name="season-02">été</term>
    <term name="season-03">automne</term>
    <term name="season-04">hiver</term>
  </terms>
</locale>`,
  "it-IT": `<?xml version="1.0" encoding="utf-8"?>
<locale xmlns="http://purl.org/net/xbiblio/csl" version="1.0" xml:lang="it-IT">
  <info>
    <translator>
      <name>FI App Development</name>
    </translator>
    <rights license="http://creativecommons.org/licenses/by-sa/3.0/">This work is licensed under a Creative Commons Attribution-ShareAlike 3.0 License</rights>
    <updated>2012-07-04T23:31:02+00:00</updated>
  </info>
  <style-options punctuation-in-quote="false"/>
  <date form="text">
    <date-part name="day" suffix=" "/>
    <date-part name="month" suffix=" "/>
    <date-part name="year"/>
  </date>
  <date form="numeric">
    <date-part name="day" form="numeric-leading-zeros" suffix="/"/>
    <date-part name="month" form="numeric-leading-zeros" suffix="/"/>
    <date-part name="year"/>
  </date>
  <terms>
    <term name="accessed">consultato</term>
    <term name="and">e</term>
    <term name="and others">e altri</term>
    <term name="anonymous">anonimo</term>
    <term name="anonymous" form="short">anon.</term>
    <term name="at">a</term>
    <term name="available at">available at</term>
    <term name="by">di</term>
    <term name="circa">circa</term>
    <term name="circa" form="short">c.</term>
    <term name="cited">citato</term>
    <term name="edition">
      <single>edizione</single>
      <multiple>edizioni</multiple>
    </term>
    <term name="edition" form="short">ed.</term>
    <term name="et-al">et al.</term>
    <term name="forthcoming">futuro</term>
    <term name="from">da</term>
    <term name="ibid">ibid.</term>
    <term name="in">in</term>
    <term name="in press">in stampa</term>
    <term name="internet">internet</term>
    <term name="interview">intervista</term>
    <term name="letter">lettera</term>
    <term name="no date">senza data</term>
    <term name="no date" form="short">s.d.</term>
    <term name="online">in linea</term>
    <term name="presented at">presentato al</term>
    <term name="reference">
      <single>reference</single>
      <multiple>references</multiple>
    </term>
    <term name="reference" form="short">
      <single>ref.</single>
      <multiple>refs.</multiple>
    </term>
    <term name="retrieved">recuperato</term>
    <term name="scale">scale</term>
    <term name="version">version</term>

    <!-- ANNO DOMINI; BEFORE CHRIST -->
    <term name="ad">d.C.</term>
    <term name="bc">a.C.</term>

    <!-- PUNCTUATION -->
    <term name="open-quote">«</term>
    <term name="close-quote">»</term>
    <term name="open-inner-quote">“</term>
    <term name="close-inner-quote">”</term>
    <term name="page-range-delimiter">–</term>

    <!-- ORDINALS -->
    <term name="ordinal">º</term>

    <!-- LONG ORDINALS -->
    <term name="long-ordinal-01">prima</term>
    <term name="long-ordinal-02">seconda</term>
    <term name="long-ordinal-03">terza</term>
    <term name="long-ordinal-04">quarta</term>
    <term name="long-ordinal-05">quinta</term>
    <term name="long-ordinal-06">sesta</term>
    <term name="long-ordinal-07">settima</term>
    <term name="long-ordinal-08">ottava</term>
    <term name="long-ordinal-09">nona</term>
    <term name="long-ordinal-10">decima</term>

    <!-- LONG LOCATOR FORMS -->
    <term name="book">
      <single>libro</single>
      <multiple>libri</multiple>
    </term>
    <term name="chapter">
      <single>capitolo</single>
      <multiple>capitoli</multiple>
    </term>
    <term name="column">
      <single>colonna</single>
      <multiple>colonne</multiple>
    </term>
    <term name="figure">
      <single>figura</single>
      <multiple>figure</multiple>
    </term>
    <term name="folio">
      <single>foglio</single>
      <multiple>fogli</multiple>
    </term>
    <term name="issue">
      <single>numero</single>
      <multiple>numeri</multiple>
    </term>
    <term name="line">
      <single>riga</single>
      <multiple>righe</multiple>
    </term>
    <term name="note">
      <single>nota</single>
      <multiple>note</multiple>
    </term>
    <term name="opus">
      <single>opera</single>
      <multiple>opere</multiple>
    </term>
    <term name="page">
      <single>pagina</single>
      <multiple>pagine</multiple>
    </term>
    <term name="number-of-pages">
      <single>pagina</single>
      <multiple>pagine</multiple>
    </term>
    <term name="paragraph">
      <single>capoverso</single>
      <multiple>capoversi</multiple>
    </term>
    <term name="part">
      <single>parte</single>
      <multiple>parti</multiple>
    </term>
    <term name="section">
      <single>paragrafo</single>
      <multiple>paragrafi</multiple>
    </term>
    <term name="sub verbo">
      <single>sub verbo</single>
      <multiple>sub verbis</multiple>
    </term>
    <term name="verse">
      <single>verso</single>
      <multiple>versi</multiple>
    </term>
    <term name="volume">
      <single>volume</single>
      <multiple>volumi</multiple>
    </term>

    <!-- SHORT LOCATOR FORMS -->
    <term name="book" form="short">lib.</term>
    <term name="chapter" form="short">cap.</term>
    <term name="column" form="short">col.</term>
    <term name="figure" form="short">fig.</term>
    <term name="folio" form="short">fgl.</term>
    <term name="issue" form="short">n.</term>
    <term name="line" form="short">l.</term>
    <term name="note" form="short">n.</term>
    <term name="opus" form="short">op.</term>
    <term name="page" form="short">
      <single>pag.</single>
      <multiple>pagg.</multiple>
    </term>
    <term name="number-of-pages" form="short">
      <single>pag.</single>
      <multiple>pagg.</multiple>
    </term>
    <term name="paragraph" form="short">cpv.</term>
    <term name="part" form="short">pt.</term>
    <term name="section" form="short">par.</term>
    <term name="sub verbo" form="short">
      <single>s.v.</single>
      <multiple>s.vv.</multiple>
    </term>
    <term name="verse" form="short">
      <single>v.</single>
      <multiple>vv.</multiple>
    </term>
    <term name="volume" form="short">
      <single>vol.</single>
      <multiple>vol.</multiple>
    </term>

    <!-- SYMBOL LOCATOR FORMS -->
    <term name="paragraph" form="symbol">
      <single>¶</single>
      <multiple>¶¶</multiple>
    </term>
    <term name="section" form="symbol">
      <single>§</single>
      <multiple>§§</multiple>
    </term>

    <!-- LONG ROLE FORMS -->
    <term name="director">
      <single>director</single>
      <multiple>directors</multiple>
    </term>
    <term name="editor">
      <single>curatore</single>
      <multiple>curatori</multiple>
    </term>
    <term name="editorial-director">
      <single>editor</single>
      <multiple>editors</multiple>
    </term>
    <term name="illustrator">
      <single>illustrator</single>
      <multiple>illustrators</multiple>
    </term>
    <term name="translator">
      <single>traduttore</single>
      <multiple>traduttori</multiple>
    </term>
    <term name="editortranslator">
      <single>curatore e traduttore</single>
      <multiple>curatori e tradutori</multiple>
    </term>

    <!-- SHORT ROLE FORMS -->
    <term name="director" form="short">
      <single>dir.</single>
      <multiple>dirs.</multiple>
    </term>
    <term name="editor" form="short">
      <single>a c. di</single>
      <multiple>a c. di</multiple>
    </term>
    <term name="editorial-director" form="short">
      <single>ed.</single>
      <multiple>eds.</multiple>
    </term>
    <term name="illustrator" form="short">
      <single>ill.</single>
      <multiple>ills.</multiple>
    </term>
    <term name="translator" form="short">
      <single>trad.</single>
      <multiple>trad.</multiple>
    </term>
    <term name="editortranslator" form="short">
      <single>a c. di e trad. da</single>
      <multiple>a c. di e trad. da</multiple>
    </term>

    <!-- VERB ROLE FORMS -->
    <term name="container-author" form="verb">di</term>
    <term name="director" form="verb">directed by</term>
    <term name="editor" form="verb">a cura di</term>
    <term name="editorial-director" form="verb">edited by</term>
    <term name="illustrator" form="verb">illustrated by</term>
    <term name="interviewer" form="verb">intervista di</term>
    <term name="recipient" form="verb">a</term>
    <term name="reviewed-author" form="verb">by</term>
    <term name="translator" form="verb">tradotto da</term>
    <term name="editortranslator" form="verb">a cura di e tradotto da</term>

    <!-- SHORT VERB ROLE FORMS -->
    <term name="director" form="verb-short">dir.</term>
    <term name="editor" form="verb-short">a c. di</term>
    <term name="editorial-director" form="verb-short">ed.</term>
    <term name="illustrator" form="verb-short">illus.</term>
    <term name="translator" form="verb-short">trad. da</term>
    <term name="editortranslator" form="verb-short">a c. di e trad. da</term>

    <!-- LONG MONTH FORMS -->
    <term name="month-01">gennaio</term>
    <term name="month-02">febbraio</term>
    <term name="month-03">marzo</term>
    <term name="month-04">aprile</term>
    <term name="month-05">maggio</term>
    <term name="month-06">giugno</term>
    <term name="month-07">luglio</term>
    <term name="month-08">agosto</term>
    <term name="month-09">settembre</term>
    <term name="month-10">ottobre</term>
    <term name="month-11">novembre</term>
    <term name="month-12">dicembre</term>

    <!-- SHORT MONTH FORMS -->
    <term name="month-01" form="short">gen.</term>
    <term name="month-02" form="short">feb.</term>
    <term name="month-03" form="short">mar.</term>
    <term name="month-04" form="short">apr.</term>
    <term name="month-05" form="short">mag.</term>
    <term name="month-06" form="short">giu.</term>
    <term name="month-07" form="short">lug.</term>
    <term name="month-08" form="short">ago.</term>
    <term name="month-09" form="short">set.</term>
    <term name="month-10" form="short">ott.</term>
    <term name="month-11" form="short">nov.</term>
    <term name="month-12" form="short">dic.</term>

    <!-- SEASONS -->
    <term name="season-01">primavera</term>
    <term name="season-02">estate</term>
    <term name="season-03">autunno</term>
    <term name="season-04">inverno</term>
  </terms>
</locale>`,
};
